// import axios from "axios";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import {
  Avatar,
  Button,
  Chip,
  Menu,
  MenuItem,
  Modal,
  Tooltip,
} from "@mui/material";
import avatarStyle from "../../assets/avatarStyle";
import ResearchDetail from "./researchDetail";
import styled from "@emotion/styled";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import axios from "../../api/PrivateApi";
import ResearchSettings from "../../components/800/ResearchSettings";

const muiCache = createCache({
  key: "mui",
  prepend: true,
});
const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
  background: theme.palette.background.default,
  height: "100%",
}));

const columns = [
  {
    name: "title",
    label: "Title",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "grant_code",
    label: "Grant Code",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "start_date",
    label: "Start Date",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "end_date",
    label: "End Date",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "type",
    label: "Type",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "approved_element",
    label: "Status",
    options: {
      filter: false,
      sort: true,
    },
  },
];

const options = {
  selectableRows: false,
};

const ResearchList = () => {
  const [result, setResult] = useState([]);
  const [staffInResearch, setStaffInResearch] = useState([]);
  const [viewResearch, setViewResearch] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const staffActionBtnOpen = Boolean(anchorEl);
  //modal
  const [modalOpen, setModalOpen] = React.useState(false);
  const handleResearchDetailOpen = (event, researchId) => {
    setViewResearch(researchId);
    setModalOpen(true);
  };
  const handleResearchDetailClose = () => {
    setModalOpen(false);
  };

  const handleStaffActionClick = async (event, researchId) => {
    setAnchorEl(event.currentTarget);
    const res = await axios(`research/staffs/${researchId}`);
    setStaffInResearch(res.data);
  };

  const handleStaffActionMenuClose = () => {
    setAnchorEl(null);
  };

  const chipStyle = (status) => {
    let color = "red";
    let label = "Server Error";

    if (status === "Active") {
      color = "green";
      label = "Active";
    } else if (status === "Extended") {
      color = "blue";
      label = "Extended";
    }

    return {
      color: color,
      label: label,
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(`research/viewActiveResearch`);

      const resultArr = [];
      res.data.forEach((data) => {
        const { id, status } = data;
        const actions = (
          <>
            <Tooltip title="Participating Staffs" placement="left">
              <PersonIcon
                onClick={(event) => handleStaffActionClick(event, id)}
                key={id}
                sx={{
                  color: "rgb(17,24,71)",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
            <Chip
              sx={{
                position: "relative",
                bottom: 10,
                marginLeft: 1,
                background: "rgba(17, 24, 71, 1)",
                color: "#fff",
                "&:hover": {
                  background: "rgba(17, 24, 71, 0.7)",
                },
              }}
              label="Details"
              onClick={(event) => handleResearchDetailOpen(event, id)}
            />
          </>
        );

        // const approved_element = <Chip {...chipStyle(status)} />;
        const approved_element = <span style={{color: chipStyle(status).color, fontWeight: 'bold'}}>{chipStyle(status).label}</span>

        resultArr.push({
          ...data,
          approved_element,
          actions,
        });
      });
      setResult(resultArr);
    };
    fetchData();
  }, []);

  return (
    <>
      {/* <div
        style={{ display: "flex", alignItems: "end", justifyContent: "end" }}
      >
        <ResearchSettings />
      </div> */}
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={"Active Researches"}
          data={result}
          columns={columns}
          options={options}
        />
      </CacheProvider>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={staffActionBtnOpen}
        onClose={handleStaffActionMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {staffInResearch.length < 1
          ? "No record found"
          : staffInResearch.map((staff, index) => {
            return (
              // <Link to="/dashboard" key={index}>
              <MenuItem>
                <Avatar
                  {...avatarStyle(staff.first_name + " " + staff.middle_name)}
                />
                <span style={{ marginLeft: "10px" }}>
                  {staff.first_name +
                    " " +
                    staff.middle_name +
                    " " +
                    staff.last_name}
                </span>
              </MenuItem>
              // </Link>
            );
          })}
      </Menu>
      <Modal
        open={modalOpen}
        onClose={handleResearchDetailClose}
        aria-labelledby="research-title-modal"
        aria-describedby="research-detail-modal"
      >
        <ResearchDetail
          closeResearchDetail={handleResearchDetailClose}
          researchId={viewResearch}
        />
      </Modal>
    </>
  );
};

export default ResearchList;
